"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var hovo_api_1 = require("../../shared/hovo-api");
var form_1 = require("../../shared/form");
var messages_1 = require("../../shared/messages");
var config_1 = require("../../shared/config");
(0, jquery_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var initializeDownloadsTable, initializeUploads, $material, subscriptions, selectItems, selector;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initializeDownloadsTable = function (courseId) {
                    return __awaiter(this, void 0, void 0, function () {
                        var downloads, config, $tableBody, _i, downloads_1, download, downloadUrl, $row, buttonClass, $deleteButton;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0: return [4 /*yield*/, (0, hovo_api_1.getCourseDownloads)(courseId)];
                                case 1:
                                    downloads = _c.sent();
                                    if (downloads) {
                                        config = (0, config_1.getHovoConfig)();
                                        $tableBody = (0, jquery_1.default)('#table-body');
                                        $tableBody.empty();
                                        for (_i = 0, downloads_1 = downloads; _i < downloads_1.length; _i++) {
                                            download = downloads_1[_i];
                                            downloadUrl = "".concat(config.apiRootUrl).concat(download.file);
                                            $row = (0, jquery_1.default)("<tr>\n<td><a href=\"".concat(downloadUrl, "\" target=\"_blank\">").concat(download.name, "</a></td>\n<td>").concat(download.extension, "</td>\n<td class=\"actions-cell\"></td>\n</tr>"));
                                            buttonClass = (_b = (_a = window.cursusmateriaal) === null || _a === void 0 ? void 0 : _a.buttonClass) !== null && _b !== void 0 ? _b : "btn-yellow";
                                            $deleteButton = (0, jquery_1.default)("<a class=\"btn ".concat(buttonClass, "\" data-download-id=\"").concat(download.id, "\">Verwijderen</a>"));
                                            $deleteButton.on("click", function () {
                                                return __awaiter(this, void 0, void 0, function () {
                                                    var downloadId, result;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                downloadId = (0, jquery_1.default)(this).data("download-id");
                                                                if (!confirm("Weet u dit zeker?")) return [3 /*break*/, 4];
                                                                return [4 /*yield*/, (0, hovo_api_1.deleteCourseDownload)(downloadId)];
                                                            case 1:
                                                                result = _a.sent();
                                                                if (!result) return [3 /*break*/, 3];
                                                                (0, messages_1.showSuccessMessage)("De download is succesvol verwijderd.");
                                                                return [4 /*yield*/, initializeDownloadsTable(courseId)];
                                                            case 2:
                                                                _a.sent();
                                                                return [3 /*break*/, 4];
                                                            case 3:
                                                                (0, messages_1.showErrorMessage)("De download kon niet worden verwijderd.");
                                                                _a.label = 4;
                                                            case 4: return [2 /*return*/];
                                                        }
                                                    });
                                                });
                                            });
                                            $row.find(".actions-cell").append($deleteButton);
                                            $tableBody.append($row);
                                        }
                                        (0, jquery_1.default)('.course-downloads').show();
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    });
                };
                initializeUploads = function (courseId) {
                    return __awaiter(this, void 0, void 0, function () {
                        var $uploadField, $uploadButton;
                        return __generator(this, function (_a) {
                            $uploadField = (0, jquery_1.default)('#file');
                            $uploadButton = (0, jquery_1.default)('#upload-button');
                            $uploadButton.off();
                            $uploadButton.on("click", function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    var files, result;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                files = $uploadField.prop("files");
                                                if (!files.length) {
                                                    (0, messages_1.showErrorMessage)("Er is geen bestand geselecteerd.");
                                                    return [2 /*return*/];
                                                }
                                                return [4 /*yield*/, (0, hovo_api_1.addDownload)(courseId, files[0])];
                                            case 1:
                                                result = _a.sent();
                                                if (!result) return [3 /*break*/, 3];
                                                return [4 /*yield*/, initializeDownloadsTable(courseId)];
                                            case 2:
                                                _a.sent();
                                                (0, messages_1.showSuccessMessage)("Het bestand is succesvol geüpload.");
                                                $uploadField.val("");
                                                return [3 /*break*/, 4];
                                            case 3:
                                                (0, messages_1.showErrorMessage)("Het bestand kon niet worden geüpload.");
                                                _a.label = 4;
                                            case 4: return [2 /*return*/];
                                        }
                                    });
                                });
                            });
                            return [2 /*return*/];
                        });
                    });
                };
                $material = (0, jquery_1.default)('.cursusmateriaal');
                if (!$material.length) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, (0, hovo_api_1.getTeacherSubscriptions)()];
            case 1:
                subscriptions = _a.sent();
                selectItems = [{
                        title: "Selecteer een cursus"
                    }];
                if (subscriptions) {
                    selectItems = selectItems.concat(subscriptions.courses.map(function (c) {
                        return {
                            title: "".concat(c.title, " (").concat(c.course_number, ")"),
                            value: c.id
                        };
                    }));
                }
                selector = "#course";
                (0, form_1.fillSelect)(selector, selectItems);
                (0, jquery_1.default)(selector).on("change", function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var $select, value, courseId;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    $select = (0, jquery_1.default)(this);
                                    value = $select.val();
                                    if (!value) return [3 /*break*/, 3];
                                    courseId = parseInt(value);
                                    return [4 /*yield*/, initializeUploads(courseId)];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, initializeDownloadsTable(courseId)];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                });
                return [2 /*return*/];
        }
    });
}); });
